import { Routes, RouterModule }  from '@angular/router';
import { Foc } from './components/main/foc.component';
import { AuthenticatedRoutesGuard } from '../app/services/authenticated-routes-guard.service';
import { StudentBookResolver } from './services/student-book-resolver.service';
import { StudentBook } from './components/books/student-book/student-book.component';
import { MediaPlayerComponent } from './components/media-player/media-player.component';
// import { ActivityLaunch } from './components/activity/activity-launch/activity-launch.component';
// import { ActivityView } from './components/activity/activity-view/activity-view.component';
// import { ActivityViewResolverService } from './services/activity-view-resolver.service';

const routes: Routes = [
    {
        path: '', component: Foc, canActivate:[AuthenticatedRoutesGuard], children: [
            { path: ':spaceId/product/:productCode/studentbook/:studentBookCode/view', component: StudentBook, resolve: { bookData: StudentBookResolver }},
            { path: ':spaceId/class/:class/product/:productCode/studentbook/:studentBookCode/view', component: StudentBook, resolve: { bookData: StudentBookResolver }},
            { path: 'media-player/:spaceId/:productCode', children: [
              { path: '**', component: MediaPlayerComponent }]
            }
            
            // { path: ':spaceId/product/:productCode/view', component: ActivityView, resolve: { activityViewResolverData: ActivityViewResolverService }, children: [
            //     { path: 'item/:itemId', component: ActivityLaunch }
            // ]}
        ]
    }
];

export const ROUTES = RouterModule.forChild(routes);
